module.exports = __webpack_public_path__ + "static/img/logo.d9befa9c.png";